<template>
  <img
    v-if="content.Loyalty.metadata.bannerLogoImageUrl"
    class="cf-image cf-image--auto-max"
    :alt="merchant.name"
    :src="content.Loyalty.metadata.bannerLogoImageUrl"
    onerror="this.src='/images/image-not-found.png';"
  >

  <img
    v-else-if="content.Loyalty.metadata.imageUrl"
    class="cf-image cf-image--logo"
    :alt="merchant.name"
    :src="content.Loyalty.metadata.imageUrl"
    onerror="this.src='/images/image-not-found.png';"
  >
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'LoyaltyBannerImage',

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>
